import Select from "@/v2-ui/select"
import { usePlanMigrationStatusesQuery } from "@/v2-backoffice-client/license/plan/view/license.plan.migrationStatuses.query"

export type LicensePlanMigrationStatusSelectProps = {
  value: string
  onValueChange(value: string): void
}

// The migration conversation-state catalog (In dialogue, Agreed, Declined) as
// a select, with the picked state's description as the hint below — owns its
// own catalog query so the migration dialog stays a one-operation component.
// The derived states (Not started, Moved, Ended) are deliberately absent:
// nobody sets those, the license does.
function LicensePlanMigrationStatusSelect(
  props: LicensePlanMigrationStatusSelectProps,
) {
  const { value, onValueChange } = props

  const { data, loading } = usePlanMigrationStatusesQuery()
  const statuses = data?.getPlanMigrationStatuses ?? []
  const selected = statuses.find((status) => String(status.Code) === value)

  return (
    <>
      <Select value={value} onValueChange={onValueChange}>
        <Select.Trigger size="md" className="w-full">
          <Select.Value
            placeholder={
              loading ? "Loading statuses..." : "Where does the dialogue stand?"
            }
          />
        </Select.Trigger>
        <Select.Content>
          {statuses.map((status) => (
            <Select.Item key={status.Code} value={String(status.Code)}>
              {status.Name}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
      {selected?.Description && (
        <p className="text-xs text-muted-foreground">{selected.Description}</p>
      )}
    </>
  )
}

export default LicensePlanMigrationStatusSelect
